/* 近代化資金の入力詳細画面フッターエリア */
import React from 'react';
import TransitionButton from './TransitionButton';
import { useHistory } from 'react-router-dom';
import { StepNavigation as StepType } from '../types/Template';
import { loan_types } from '../Const';
interface Props {
  reception_cd: string;
  reception_id: number;
  status: number;
  looks_inactive: boolean;
  setLabel?: React.Dispatch<React.SetStateAction<string>>;
  setStepNavigation?: React.Dispatch<React.SetStateAction<StepType>>;
  setDisplayReceptionCd?: React.Dispatch<React.SetStateAction<boolean>>;
  setDisplayStatus?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModernizationFundsFooterAreaButtons: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status,
  looks_inactive,
  setLabel,
  setStepNavigation,
  setDisplayReceptionCd,
  setDisplayStatus,
}) => {
  const history = useHistory();
  // 前の画面に戻る
  const handleClick = () => {
    // 借入申込希望書兼経営改善資金計画書完了・近代化資金借入申込完了 画面から遷移してきた場合は、完了画面に遷移
    // 入力種別選択画面から遷移してきた場合は、入力種別選択画面に遷移
    // note SPAでリファラで遷移元の情報を取得できないので、sessionStorageを使用
    if (sessionStorage.getItem('from_to_completeed') === 'true') {
      const from_to_item_id = sessionStorage.getItem('from_to_item_id');
      setStepNavi(from_to_item_id);

      sessionStorage.removeItem('from_to_item_id');
      sessionStorage.removeItem('from_to_completeed');

      history.push({
        pathname: `/reception/${reception_cd}/${reception_id}/${status}/complete`,
        search: `?item_id=${from_to_item_id}`,
      });
    } else {
      location.href = `${location.origin}${process.env.MIX_MOCK_URL}/modernization_funds/input_type_select/${reception_cd}/${reception_id}`;
    }
  };

  /**
   * ステップナビゲーションを設定
   * @param {string|null} from_to_item_id 遷移元の商品ID
   */
  const setStepNavi = (from_to_item_id: string | null) => {
    if (
      typeof setStepNavigation === 'undefined' ||
      typeof setLabel === 'undefined' ||
      typeof setDisplayReceptionCd === 'undefined' ||
      typeof setDisplayStatus === 'undefined'
    ) {
      return;
    }

    // ステップナビゲーションを設定
    const title =
      from_to_item_id === loan_types.business_improvement_financing_plan
        ? '借入申込希望書兼経営改善資金計画書'
        : '借入申込';

    setLabel(title);
    setDisplayReceptionCd(false);
    setDisplayStatus(false);
    setStepNavigation({
      step1: '借入申込',
      step2: '書類提出',
      step3: '借入申込\n入力確認',
      step4: '完了',
      current: 4,
      show: true,
    });
  };

  // 確認画面のときに「戻る」ボタン押下時
  const backTransition = () => {
    location.replace(document.referrer);
};

  return (
    <div className="footer-button-group">
      <TransitionButton label="戻る" handleClick={looks_inactive ? backTransition : handleClick} />
    </div>
  );
};

export default ModernizationFundsFooterAreaButtons;
